import { render, staticRenderFns } from "./settings2.vue?vue&type=template&id=3439671e&scoped=true"
import script from "./settings2.vue?vue&type=script&lang=js"
export * from "./settings2.vue?vue&type=script&lang=js"
import style0 from "./settings2.vue?vue&type=style&index=0&id=3439671e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439671e",
  null
  
)

export default component.exports